import React from "react";
import { Box, Typography, Container } from "@mui/material";

// ----- Brand Palette -----
const BRAND = {
  background: "#E0F2FF", // light blue
  primary: "#0B3D91",
  secondary: "#64B5F6",
  accentGray: "#0B3D91",
  paper: "#FFFFFF",
  border: "#90CAF9",
};

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        borderTop: `1px solid ${BRAND.border}`,
        bgcolor: BRAND.background, // light blue background
      }}
    >
      <Container maxWidth="lg">
        <Box py={3} textAlign="center">
          <Typography
            variant="body2"
            sx={{ color: BRAND.accentGray, fontWeight: 400 }}
          >
            © {new Date().getFullYear()} AthEcoScope. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
